import mountVue from '@src/mount'
import { router, components } from '@src/pages'

mountVue(router, components)
